import React, {Component} from "react";
import {FormattedMessage} from "react-intl";
import {ITEM_COUNT_PER_PAGE, RESOURCE_BASE_URL} from "../../../../../configuration";
import axios from "axios";
import ArticlesHeader from "../ArticlesHeader/ArticlesHeader";
import ArticlesRow from "../ArticlesRow/ArticlesRow";
import ArticlesBottom from "../ArticlesBottom/ArticlesBottom";

class ArticlesTable extends Component {

    constructor(props) {
        super(props);
        this.state = {
            articles: [],
            totalItemCount: 0,
            activePage: 1
        };
        this.getArticles = this.getArticles.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
    }
    componentDidMount() {
        this.getArticles(0, ITEM_COUNT_PER_PAGE);
    }

    handlePageChange = (pageNumber) => {
        // console.log(`active page is ${pageNumber}`);

        this.setState({activePage: pageNumber});

        let offset = (pageNumber-1) * ITEM_COUNT_PER_PAGE;
        this.getArticles(pageNumber-1, ITEM_COUNT_PER_PAGE);
    };

    getArticles = (offset, limit) => {
        // console.log("limit",limit,offset);
        axios.get(RESOURCE_BASE_URL + 'api/articles?offset=' + offset + '&limit=' + limit )
            .then((res) => {
                this.setState({
                    articles: res.data.articles.content,
                    totalItemCount: res.data.rowCount
                });
                // console.log(res.data);
            })
            .catch((err) => {
                this.setState(
                    {
                        inquiries: []
                    });
                console.log("[API] ERROR: ", err);
            });
    };


    render() {
        let sortJsonArray = require('sort-json-array');
        let sortedArticles=sortJsonArray(this.state.articles, 'createdDate','des');
        let no = 1;
        return (
            <div className="row">
                <div className="row">
                    <div className="col-md-6 remove-left-padding">
                        <div className="title-1-articles">
                            <FormattedMessage id="app.all-articles-title.title"
                                              defaultMessage="ARTICLES"
                                              description=""/>
                        </div>
                    </div>
                    <div>
                        <div className="col-md-6">
                        </div>

                    </div>
                </div>
                <div className="row admin-tables">
                    <div className="admin-table-row-content">
                        <table className="table table-bordered article-table-resp">
                            <ArticlesHeader/>

                           <tbody>
                               {this.state.articles.length !== 0 ?

                                   sortedArticles.map(articles => {
                                       return <ArticlesRow  articles={articles} no={no++} getAll={this.getArticles}/>

                                   }) : <tr><td colSpan={5}>
                                       <div className="text-center"><FormattedMessage id="app.order.all.no-records"
                                                                                      defaultMessage="No Records Found"
                                                                                      description=""/></div>
                                   </td></tr>
                               }
                           </tbody>
                        </table>

                   </div>
                </div>
                <ArticlesBottom activePage={this.state.activePage}
                                itemsCountPerPage={ITEM_COUNT_PER_PAGE}
                                totalItemsCount={this.state.totalItemCount}
                                handlePageChange={this.handlePageChange}/>
            </div>

        )
    }
}

export default ArticlesTable;


// WEBPACK FOOTER //
// ./src/components/Admin/Articles/ViewAllArticles/ArticleTable/ArticlesTable.js